import { Injectable, OnDestroy } from '@angular/core';
import { RolesService } from '@services/auth/role.service';
import { PortalState } from '@view-models/enums/portal-state';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreAppService implements OnDestroy {
  subscription = new Subscription();
  private portalStateSubj$ = new BehaviorSubject<PortalState>(PortalState.SOURCE_SITE);
  portalState$ = this.portalStateSubj$.asObservable();

  constructor(private roleService: RolesService) {
    this.subscription.add(
      this.roleService.onlyFillSite$.subscribe(onlyFillSite => {
        if (onlyFillSite) {
          this.setPortalState(PortalState.FILL_SITE);
        }
      })
    );
  }

  setPortalState(state: PortalState): void {
    this.portalStateSubj$.next(state);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
